export default __webpack_public_path__ + "static/media/target-empty-state.d8ac47d6.svg";